/** ************************************************************
                        Feedback API
************************************************************* */
/** Check if user can use email */
export const ApiSignUpPost = () => ({
  method: 'POST',
  url: 'https://api.airtable.com/v0/app8A0DC0a7xswBBp/Signups',
  data: {},
});
